import React from 'react'
import classNames from 'classnames'

const createSpacingComponent = level => ({
  className,
  children,
  type = 'div',
  butFirst,
  butLast,
  ...props
}) => {
  const baseClass = `et-${level}`
  const propsToClassNames = () => {
    return Object.keys(props)
      .filter(key => key.match(/^(m|p)(r|l|t|b)?$/) && props[key] !== undefined)
      .map(propKey => {
        const spaceClass = propKey.split('').join('-')
        return `${baseClass}-${spaceClass}-${props[propKey]}`
      })
  }
  return React.createElement(
    type,
    {
      className: classNames(className, propsToClassNames(), {
        '--but-first': butFirst,
        '--but-last': butLast
      }),
      ...props
    },
    children
  )
}
export default createSpacingComponent
